import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const ContactCTA = () => {
  return (
    <section className="py-24 bg-[#4D4C4A] text-white relative overflow-hidden">
      {/* Decorative Grid */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
        <div className="grid grid-cols-12 h-full">
          {[...Array(12)].map((_, i) => (
            <div key={i} className="border-r border-white"></div>
          ))}
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-center gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-6 italic">Regional Coverage</h2>
            <h3 className="text-4xl md:text-5xl font-bold italic tracking-tighter leading-tight mb-8">
              Serving the Entire <br />
              <span className="text-[#91756A]">United Arab Emirates</span>.
            </h3>
            <p className="text-white/60 text-lg italic font-light">
              From our headquarters in Sharjah to projects across Dubai and Abu Dhabi, our team is mobile and ready to respond to your technical needs 24/7.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="shrink-0"
          >
            <div className="w-48 h-48 border-2 border-[#91756A]/30 rounded-full flex items-center justify-center relative">
              <div className="w-32 h-32 bg-[#91756A] rounded-full flex items-center justify-center animate-pulse">
                <Icon name="Globe" size={48} className="text-white" />
              </div>
              <div className="absolute inset-0 border border-white/10 rounded-full animate-ping"></div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom Accent */}
      <motion.div 
        initial={{ width: 0 }}
        whileInView={{ width: "100%" }}
        viewport={{ once: true }}
        transition={{ duration: 2 }}
        className="absolute bottom-0 left-0 h-1 bg-[#91756A]"
      ></motion.div>
    </section>
  );
};

export default ContactCTA;